<template>
  <div id="ReportTicketSalesWithDetails">
    <TitleReportsCard
      title="Boletos vendidos con detalle"
      :loading="loading"
      @generateReport="generateReport"
    >
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <InputDatePickerReport
          v-model="dateStart"
          :newMax="dateEnd"
          label="Seleccione una fecha de inicio"
          type="month"
          :disabled="loading"
          @change="generated = false"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <InputDatePickerReport
          v-model="dateEnd"
          label="Seleccione una fecha de fin"
          type="month"
          :disabled="loading"
          @change="generated = false"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="6"
      >
        <v-select
          v-model="placeSelected"
          prepend-icon="mdi-bank"
          dense
          outlined
          :items="placesForUser"
          name="id"
          item-text="name"
          item-value="id"
          label="Seleccione un parador"
          background-color="white"
          :disabled="loading"
          @change="generated = false"
        />
      </v-col>
    </TitleReportsCard>

    <ContentReportsCard
      :loading="loading"
      :generated="generated"
      :fileName="fileName"
      :noData="!ticketsDetails.length"
    >
      <ReportTicketSalesWithDetailsTable
        :dateStart="dateStart"
        :dateEnd="dateEnd"
        :titleReport="getTitleReport"
        :ticketsDetails="ticketsDetails"
        :soldTickets="soldTickets"
        :exchangedTickets="exchangedTickets"
        :totalTickets="totalTickets"
        :totalSales="totalSales"
      />
    </ContentReportsCard>
  </div>
</template>

<script>
import { mapState } from 'vuex'

// Components
import TitleReportsCard from '../tools/reports/TitleReportsCard.vue'
import InputDatePickerReport from '../tools/reports/InputDatePickerReport.vue'
import ContentReportsCard from '../tools/reports/ContentReportsCard.vue'
import ReportTicketSalesWithDetailsTable from './ReportTicketSalesWithDetailsTable.vue'

export default {
  name: 'ReportTicketSalesWithDetails',
  components: { TitleReportsCard, InputDatePickerReport, ContentReportsCard, ReportTicketSalesWithDetailsTable },
  data () {
    return {
      dateStart: '',
      dateEnd: '',
      loading: false,
      generated: false,
      placeSelected: null,
      ticketsDetails: [],
      soldTickets: 0,
      exchangedTickets: 0,
      totalTickets: 0,
      totalSales: 0
    }
  },
  computed: {
    ...mapState('dashboard', ['placesForUser']),
    namePlaceSelected: function () {
      let name = ''
      this.placesForUser.forEach(element => {
        if (element.id === this.placeSelected) name = element.name
      })
      return name
    },
    fileName: function () {
      return 'Boletos_vendidos_con_detalle_' + this.namePlaceSelected + '_del_' + this.dateStart + '_hasta_' + this.dateEnd
    },
    getTitleReport: function () {
      return `Boletos vendidos con detalle de "${this.namePlaceSelected}"`
    }
  },
  mounted () {
    this.dateStart = this.$sumarDias2(new Date())
    this.dateEnd = this.$sumarDias2(new Date())
  },
  methods: {
    generateReport: function () {
      if (!this.placeSelected) {
        this.$swalAlert('warning', 'Seleccione un parador!')
        return
      }

      this.ticketsDetails = []
      this.loading = true
      this.generated = false

      const data = {
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        placeSelected: this.placeSelected
      }
      this.$root.post('/reports/ticketSalesDetails', data)
        .then(response => {
          const data = response.data
          if (data?.success === 'FALSE') {
            this.$swalAlert('error', null, data.message)
            return
          }
          const ticketsDetails = data[0]

          let soldTickets = 0
          let exchangedTickets = 0
          let totalTickets = 0
          let totalSales = 0

          ticketsDetails.forEach(element => {
            const { Cantidad, Canje, Boleto, total } = element
            const amount = Number(Cantidad) || 0

            soldTickets += amount
            exchangedTickets += Number(Canje) || 0
            totalTickets += Number(Boleto) || 0
            totalSales += Number(total) || 0
          })

          this.ticketsDetails = ticketsDetails
          this.soldTickets = soldTickets
          this.exchangedTickets = exchangedTickets
          this.totalTickets = totalTickets
          this.totalSales = totalSales
        })
        .finally(() => {
          this.loading = false
          this.generated = true
        })
    }
  }
}
</script>

<style>

</style>
